// Gauss/Meeus algorithm for Western Easter (used in France).
// Ported from the original almanach.free.fr getPaques().
export function easterSunday(year: number): Date {
  const b = year - 1900;
  const c = year % 19;
  const d = Math.floor((7 * c + 1) / 19);
  const e = (11 * c + 4 - d) % 29;
  const f = Math.floor(b / 4);
  const g = (b + f + 31 - e) % 7;
  const avril = 25 - e - g;
  return avril > 0 ? new Date(year, 3, avril) : new Date(year, 2, avril + 31);
}
